<template>
	<MarketSoundingDecisionConfirmModal
		title-single-key="marketSoundingDecision.setNotInterested.confirm.title"
		title-multi-key="marketSoundingDecision.setNotInterested.selected.confirm.title"
		msg-single-key="marketSoundingDecision.setNotInterested.confirm.msg"
		msg-multi-key="marketSoundingDecision.setNotInterested.selected.confirm.msg"
		:evaluation-status="enumDef.InvestorSellerDebtorConfigStatus.Rejected"
		evaluation-msg-key="marketSoundingDecision.companyEvaluation.setNotInterested.msg"
		evaluation-matching-decision-msg-single-key="marketSoundingDecision.companyEvaluation.setNotInterested.alreadyMatchingDecision.single.msg"
		evaluation-matching-decision-msg-multiple-key="marketSoundingDecision.companyEvaluation.setNotInterested.alreadyMatchingDecision.multiple.msg"
		evaluation-not-matching-decision-msg-single-key="marketSoundingDecision.companyEvaluation.setInterested.alreadyMatchingDecision.single.msg"
		evaluation-not-matching-decision-msg-multiple-key="marketSoundingDecision.companyEvaluation.setInterested.alreadyMatchingDecision.multiple.msg"
		evaluation-preference-key="rejectCompaniesOnDecision"
		evaluate-label-key="marketSoundingDecision.companyEvaluation.choice.reject"
		evaluate-not-label-key="marketSoundingDecision.companyEvaluation.choice.doNotReject"
		:include-reason="true"
		:max-company-list-height="150"
		@confirm="onConfirm"
		ref="base"
	/>
</template>
<script>
import MarketSoundingDecisionConfirmModalBase from "src/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionConfirmModalBase.vue";
import {enumDef} from "@/common/enumDefs";

export default {
	components: { MarketSoundingDecisionConfirmModal: MarketSoundingDecisionConfirmModalBase },
	data() {
		return {
			enumDef: enumDef
		};
	},
	methods: {
		// Delegate methods
		showWithSingleRow(data) {
			this.$refs.base.showWithSingleRow(data);
		},
		showWithMultipleRows(rows) {
			this.$refs.base.showWithMultipleRows(rows);
		},
		onConfirm(...args) {
			// Forward event with original signature
			this.$emit('confirm', ...args);
		},
	},
};
</script>
